import React from 'react';
import './Projects.css';
import projKohls from '../assets/proj_kohls.png';
import projAutonomous from '../assets/proj_autonomous.png';
import projYolo from '../assets/proj_yolo.png';

const PROJECTS = [
  {
    title: 'Transitioning Drive-by-Wire to Autonomous Driving Systems',
    subtitle: 'Autonomous Vehicles and Robotics Laboratory',
    timeframe: '2024–2025',
    description:
      'Integrated sensing, mapping, and system software to transition a Chrysler Pacifica Plug-in Hybrid from drive-by-wire operation to an autonomous driving platform using ROS and Autoware.',
    tags: ['Autonomous Vehicles', 'ROS', 'Autoware', 'Sensor Fusion'],
    image: projAutonomous,
    links: [
      { label: 'Demo', href: 'https://mediahub.unl.edu/media/23715' },
      { label: 'Lab', href: 'https://avrlab.unl.edu/' },
      { label: 'Team', href: 'https://avrlab.unl.edu/team-members/' },
      { label: 'Paper', href: 'https://arxiv.org/pdf/2410.06492' },
    ],
  },
  {
    title: 'Multi-Threaded YOLOv7 Object Detection for Drones on Jetson Orin Nano',
    subtitle: 'Real-Time Drone Infrastructure Monitoring',
    timeframe: '2024–2025',
    description:
      'Built a multi-threaded TensorRT and ROS pipeline for on-device object detection, streaming annotated imagery and detection summaries for real-time infrastructure monitoring.',
    tags: ['Computer Vision', 'TensorRT', 'Jetson Orin Nano', 'ROS'],
    image: projYolo,
    links: [{ label: 'GitLab', href: 'https://gitlab.com/ruman23/yolov7_ros' }],
  },
  {
    title: 'Healthcare Transaction Analytics (Kohll’s Rx)',
    subtitle: 'Business Intelligence App built with R Shiny',
    timeframe: '2025',
    description:
      'Designed and developed a Windows-based analytics application to support business reporting and decision-making for Kohll’s Rx.',
    tags: ['R Shiny', 'Analytics', 'Dashboard Design'],
    image: projKohls,
    links: [],
  },
];

function Projects() {
  return (
    <section id="projects" className="site-section" aria-labelledby="projects-heading">
      <div className="site-section-inner projects-shell">
        <div className="section-heading">
          <p className="section-kicker">Projects</p>
          <h2 id="projects-heading" className="section-title">Selected Systems and Applied Work</h2>
          <p className="section-intro">
            Recent projects across autonomous vehicles, edge AI, and applied
            analytics with an emphasis on working systems, not just prototypes.
          </p>
        </div>

        <div className="projects-grid">
          {PROJECTS.map((project) => (
            <article key={project.title} className="project-card card-surface">
              <div className="project-media">
                <img src={project.image} alt={project.title} loading="lazy" />
              </div>

              <div className="project-content">
                <div className="project-topline">
                  <span>{project.subtitle}</span>
                  <span>{project.timeframe}</span>
                </div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>

                <div className="tag-list">
                  {project.tags.map((tag) => (
                    <span key={tag} className="tag-pill">{tag}</span>
                  ))}
                </div>

                {project.links.length > 0 && (
                  <div className="project-links">
                    {project.links.map((link) => (
                      <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" className="action-button">
                        {link.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
